import selector from "web/icons/selector.svg"

export default function CurrencySelector({
  value,
  onChange,
  onFocus,
  onBlur,
  units,
  disabled = false,
}) {
  return (
    <select
      className="box-border h-full w-full cursor-pointer appearance-none border-l-0 border-neutral-8 bg-white bg-no-repeat pr-6 text-sm text-neutral-5"
      style={{
        backgroundImage: selector,
        backgroundPosition: "right 5px center",
        backgroundSize: "20px",
        textAlignLast: "center",
      }}
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      tabIndex={-1}
      disabled={disabled}
    >
      {[...units].sort().map((unit) => (
        <option key={unit} value={unit}>
          {unit}
        </option>
      ))}
    </select>
  )
}
